import React from "react"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: {
        schedule: () => <span>Schedule</span>,
        travel: () => <span>Travel</span>,
        thingsToDo: () => <span>Things to Do</span>,
        faq: () => <span>FAQs</span>,
        //registry: () => <span>Registry</span>,
        rsvp: () => <span>RSVP</span>,
        //signOut: () => <span>Sign Out</span>,
        //signIn: () => <span>Sign In</span>,
        //manageRsvp: () => <span>Manage RSVP</span>,
    },
    [LANGUAGE.ZH]: {
        schedule: () => <span>日程</span>,
        travel: () => <span>旅行</span>,
        thingsToDo: () => <span>可以做的事情</span>,
        faq: () => <span>常见问题</span>,
        //registry: () => <span>Registre</span>,
        rsvp: () => <span>请尽快回复</span>,
        //signOut: () => <span>Registra't</span>,
        //signIn: () => <span>Inicia Sessió</span>,
        //manageRsvp: () => <span>Gestiona RSUP</span>,
    },
}
